export default {
	about: {
		title: false,
	},
	main: {
		tagline: false,
	},
	services: {
		title: true,
	},
	accolades: {
		title: true,
	},
	widgets: {
		title: true,
	},
	testimonials: {
		title: true,
		navButtonColor: '#100e66',
	},
	contact: {
		title: true,
	},
};
